<template>
  <section id="section1" >

      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="center">
            <v-col cols="12" md="9" xl="9">
              <div class="text-center mt-4">
                <h1 class="section-title font-weight-light">Задайте вопрос эксперту напрямую</h1>
              </div>
            </v-col>
            <v-col cols="12" md="9" xl="9" class="mt-6 mb-6 section1-cards" style="padding-left: 0; padding-right: 0;">
              <v-row>
                <v-col md="4" v-for="(panel, i) in panels" :key="i" class="expert-panel" :title="panel.text">
                  <v-hover v-slot="{ hover }">
                    <a :href="panel.href" :class="{ up: hover }">
                      <div style="background-color: transparent; color: red; text-align: center;">
                        <v-img :eager="true" :class="{ 'zoom-efect': hover }" class="d-block ml-auto mr-auto" :src="panel.img"
                               max-width="200px"></v-img>
                        <div class="text" :style="panel.textStyle">
                          {{ panel.text }}
                        </div>
                      </div>
                    </a>
                  </v-hover>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

  </section>
</template>

<script>
export default {
  data() {
    return {
      panels: [
        {
          href: "https://t.me/+79127916470",
          img: require("@/assets/image/te2.png"),
          text: "Написать в Telegram",
          textStyle: "color: #095e82"
        },
        {
          href: "viber://chat?number=%2B79127916470",
          img: require("@/assets/image/vib2.png"),
          text: "Написать в Viber",
          textStyle: "color: #311f9d"
        },
        {
          href: "https://wa.me/79127916470",
          img: require("@/assets/image/wa2.png"),
          text: "Написать в WhatsApp",
          textStyle: "color: #0c893b"
        }
      ]
    };
  },
};
</script>

<style lang="scss">
#section1 .v-parallax__image-container {
  opacity: 0.5;
}


::v-deep .v-parallax__image {
  transform: translate(-45%, 100px) !important;
  height: 600px;
}

.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}

.svg-border-waves img {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-bottom: -2px;
  z-index: -1;
}

.zoom-efect {
  transform: scale(1.01);
  transition: 0.2s ease-out;
}

.expert-panel {
  a {
    text-decoration: none;
  }

  .text {
    padding-top: 10px;
    font-weight: bold;
  }
}
</style>
